/* ============================================================
   SOLARKONTOR · Autarkie-Guide v3
   Fachliche Grundlage: Ratgeber "Strom im Camper – Dein Weg zum
   passenden Setup".

   Einbettung: Alles laeuft in einer IIFE, es entstehen keine
   globalen Variablen. Alle DOM-Zugriffe sind auf den Wurzelknoten
   des Guides beschraenkt.

   v3: Eine Spalte, ein Weg. Oben Fortschritt, unten Weiter/Zurueck,
   keine Seitenleisten. Geraete werden angetippt statt eingetippt,
   Laufzeiten mit -/+ eingestellt.
   ============================================================ */
(function () {
  "use strict";

  var ROOT_ID = "autarkie-guide";
  /* Neuer Schluessel: v3 hat andere Schritte und Geraetenamen. Ein
     alter Stand wuerde sonst auf einem Schritt landen, den es nicht
     mehr gibt. */
  var STORE_KEY = "sk-autarkie-guide-v3";

  function boot() {

    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    if (root.getAttribute("data-ag-ready") === "1") return;
    root.setAttribute("data-ag-ready", "1");

    /* ============ Konstanten ============ */

    /* Wirkungsgrad Wechselrichter. Wird sowohl fuer den Verbrauchs-
       aufschlag als auch fuer den DC-Strom auf der Batterieseite
       benutzt – beides muss mit derselben Zahl rechnen. */
    var INV_ETA = 0.88;
    /* Wirkungsgrad Ladebooster (DC/DC) */
    var BOOST_ETA = 0.92;
    /* Alternator Charger fuer Powerstation, Ratgeber Kapitel 7: bis 800 W */
    var ALT_CHARGER_W = 800;

    var TECH = {
      lifepo4: { label: "Lithium (LiFePO₄)", sub: "Fast die ganze Kapazität nutzbar, leicht und sehr langlebig. Teurer in der Anschaffung.", dod: 0.9, kg: 13, cyc: "3.000–5.000" },
      agm:     { label: "AGM", sub: "Günstig und bewährt. Nur etwa die Hälfte nutzbar und deutlich schwerer.", dod: 0.5, kg: 30, cyc: "300–800" },
      gel:     { label: "Gel", sub: "Robust, entlädt sich kaum von selbst. Ebenfalls nur etwa die Hälfte nutzbar.", dod: 0.5, kg: 32, cyc: "500–800" }
    };

    /* Mitteleuropa steht so im Ratgeber (Sommer 4-6 h, Winter 1-2 h).
       Sued- und Nordeuropa sind ergaenzt und im UI als solche markiert. */
    var SUN = {
      mitte: { label: "Mitteleuropa", sommer: 5, uebergang: 3, winter: 1.5, src: true },
      sued:  { label: "Südeuropa / Nordafrika", sommer: 6.5, uebergang: 4.5, winter: 2.5, src: false },
      nord:  { label: "Skandinavien / Nordeuropa", sommer: 5.5, uebergang: 2.5, winter: 0.7, src: false }
    };
    var SEASON = { sommer: "Sommer", uebergang: "Frühling und Herbst", winter: "Winter" };

    var CTRL_SIZES  = [10, 15, 20, 30, 40, 50, 60, 70, 80, 100];
    var INV_SIZES   = [300, 500, 800, 1000, 1200, 1500, 2000, 2500, 3000, 4000];
    var BOOST_SIZES = [20, 30, 40, 50, 60];
    var Q_SIZES     = [1.5, 2.5, 4, 6, 10, 16, 25, 35, 50, 70, 95, 120];
    /* Strombelastbarkeit einadrig, frei verlegt, ca. 30 Grad C.
       Ergaenzt – im Ratgeber nicht enthalten. */
    var Q_AMP  = { 1.5: 18, 2.5: 26, 4: 34, 6: 44, 10: 61, 16: 82, 25: 108, 35: 135, 50: 168, 70: 207, 95: 250, 120: 292 };
    var FUSE_SIZES = [15, 20, 30, 40, 50, 60, 80, 100, 125, 150, 200, 250, 300, 400];

    var uid = 0;
    function D(n, w, h, ac, sim, off) {
      uid += 1;
      return { id: "d" + uid, n: n, w: w, h: h, ac: !!ac, on: !off, sim: !!sim };
    }

    /* Geraetekatalog. Die Namen sind dieselben wie in den Profilen –
       daran erkennt eine Kachel, ob das Geraet schon in der Liste
       steht. Werte sind Richtwerte zum Anpassen. */
    var CATALOG = [
      { g: "Immer dabei", items: [
        { n: "LED-Beleuchtung", w: 10, h: 5 },
        { n: "Kompressor-Kühlschrank", w: 50, h: 10 },
        { n: "Kühlbox", w: 40, h: 3 },
        { n: "Wasserpumpe", w: 60, h: 0.4 },
        { n: "Heizung (Steuerung & Lüfter)", w: 25, h: 6 },
        { n: "Dachlüfter", w: 12, h: 4 }
      ]},
      { g: "Laden & Arbeiten", items: [
        { n: "Smartphone laden", w: 10, h: 2 },
        { n: "Tablet laden", w: 15, h: 1.5 },
        { n: "Laptop", w: 60, h: 3 },
        { n: "Monitor", w: 25, h: 5 },
        { n: "Router / MiFi", w: 8, h: 10 },
        { n: "Kamera-Ladegerät", w: 25, h: 0.5 },
        { n: "Fernseher", w: 45, h: 2 }
      ]},
      { g: "Küche & 230-V-Geräte", items: [
        { n: "Wasserkocher", w: 1500, h: 0.1, ac: true },
        { n: "Kaffeemaschine", w: 1000, h: 0.15, ac: true },
        { n: "Induktionskochfeld", w: 1800, h: 0.3, ac: true },
        { n: "Mixer", w: 300, h: 0.1, ac: true },
        { n: "E-Bike-Ladegerät", w: 250, h: 2, ac: true },
        { n: "Luftkompressor", w: 600, h: 0.1, ac: true }
      ]},
      { g: "Besondere Geräte", items: [
        { n: "CPAP-Gerät", w: 40, h: 7 },
        { n: "Navi / GPS", w: 12, h: 2 },
        { n: "Funkgerät (CB)", w: 8, h: 1 },
        { n: "Außenkamera", w: 3, h: 24 }
      ]}
    ];

    var PROFILES = {
      mini: {
        label: "Mini-System", sub: "Licht, Handy laden, kleine Kühlbox — nur das Nötigste.", days: 2,
        batt: "AGM oder eine kleine Lithium-Batterie",
        ref: { wh: "150–200 Wh", batt: "60 Ah LiFePO₄", solar: "ca. 120 Wp", inv: "500–1.000 W", q: "6–10 mm²", fuse: "30–50 A" },
        dev: function () { return [D("LED-Beleuchtung", 10, 4), D("Kühlbox", 40, 3), D("Smartphone laden", 10, 1.5), D("Kamera-Ladegerät", 25, 0.5)]; }
      },
      weekend: {
        label: "Wochenend-Van", sub: "Kühlschrank, Wasserpumpe, Laptop und ab und zu ein Wasserkocher.", days: 3,
        batt: "AGM oder eine kleine Lithium-Batterie",
        ref: { wh: "800–1.500 Wh", batt: "200–300 Ah LiFePO₄", solar: "350–400 Wp", inv: "1.500 W", q: "z. B. 35 mm²", fuse: "100 A" },
        dev: function () {
          return [D("LED-Beleuchtung", 10, 5), D("Kompressor-Kühlschrank", 50, 10), D("Wasserpumpe", 60, 0.4),
            D("Heizung (Steuerung & Lüfter)", 25, 6), D("Laptop", 60, 3), D("Smartphone laden", 10, 2),
            D("Router / MiFi", 8, 10), D("Wasserkocher", 1500, 0.1, true, true)];
        }
      },
      vollautark: {
        label: "Vollautarker Ausbau", sub: "Lange unterwegs, Induktion, Arbeiten im Camper.", days: 4,
        batt: "Lithium mit ausreichender Kapazität, eventuell mit 24 V",
        ref: { wh: "1.800–2.500 Wh und mehr", batt: "ab 400 Ah LiFePO₄", solar: "600–800 Wp", inv: "2.000–3.000 W", q: "großzügig ausgelegt", fuse: "passend zum Querschnitt" },
        dev: function () {
          return [D("LED-Beleuchtung", 12, 6), D("Kompressor-Kühlschrank", 55, 14), D("Wasserpumpe", 60, 0.6),
            D("Heizung (Steuerung & Lüfter)", 30, 8), D("Laptop", 65, 6), D("Monitor", 25, 5),
            D("Smartphone laden", 20, 3), D("Router / MiFi", 8, 16),
            D("Induktionskochfeld", 1800, 0.3, true, true), D("Kaffeemaschine", 1000, 0.15, true, false)];
        }
      },
      eigen: {
        label: "Eigene Auswahl", sub: "Du stellst Deine Geräte selbst zusammen.", days: 3,
        batt: "",
        ref: null,
        dev: function () { return []; }
      }
    };

    var STEPS = [
      { id: "s1", t: "Reisestil" },
      { id: "s2", t: "Geräte" },
      { id: "s3", t: "Batterie" },
      { id: "s4", t: "Solar" },
      { id: "s5", t: "Wechselrichter" },
      { id: "s6", t: "Wochencheck" },
      { id: "s7", t: "Kabel" },
      { id: "s8", t: "Ergebnis" }
    ];

    /* ============ Zustand ============ */
    function freshState() {
      return {
        v: 3, step: 0, profile: "weekend", days: 3, reserve: 1.25, volt: 12,
        tech: "lifepo4", region: "mitte", season: "sommer",
        sun: 5, pr: 0.8, acLoss: false,
        devices: PROFILES.weekend.dev(),
        battAh: null, solarWp: null,
        voc: 22.3, isc: 9, series: 2, parallel: 1,
        alt: 120, altCharger: false, drive: 2, driveH: 2, bad: 2, land: false,
        cabI: null, cabL: 1.5, cabU: 3
      };
    }
    var S = freshState();

    /* ============ Helfer ============ */
    function q(sel) { return root.querySelector(sel); }
    function el(t, c, x) { var e = document.createElement(t); if (c) e.className = c; if (x !== undefined) e.textContent = x; return e; }
    function nf(v, d) {
      if (v === null || v === undefined || !isFinite(v)) return "–";
      d = d || 0;
      return v.toLocaleString("de-DE", { minimumFractionDigits: d, maximumFractionDigits: d });
    }
    function up(list, v) { for (var i = 0; i < list.length; i++) { if (list[i] >= v) return list[i]; } return list[list.length - 1]; }
    function down(list, v) { var r = list[0]; for (var i = 0; i < list.length; i++) { if (list[i] <= v) r = list[i]; } return r; }
    function esc(s) { return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }

    /* ============ Rechnen ============ */
    function acFactor() { return S.acLoss ? 1 / INV_ETA : 1; }

    function deviceWh(d) {
      var wh = (+d.w || 0) * (+d.h || 0);
      if (d.ac) wh *= acFactor();
      return wh;
    }
    function dailyWh() {
      var s = 0;
      for (var i = 0; i < S.devices.length; i++) { if (S.devices[i].on) s += deviceWh(S.devices[i]); }
      return s;
    }
    /* Summe der 230-V-Geraete, die gleichzeitig laufen sollen */
    function acSimW() {
      var s = 0;
      for (var i = 0; i < S.devices.length; i++) { var d = S.devices[i]; if (d.on && d.ac && d.sim) s += (+d.w || 0); }
      return s;
    }
    /* Summe ALLER aktiven 230-V-Geraete */
    function acSumW() {
      var s = 0;
      for (var i = 0; i < S.devices.length; i++) { var d = S.devices[i]; if (d.on && d.ac) s += (+d.w || 0); }
      return s;
    }
    /* Groesste einzelne 230-V-Last */
    function acMaxW() {
      var m = 0;
      for (var i = 0; i < S.devices.length; i++) { var d = S.devices[i]; if (d.on && d.ac && (+d.w || 0) > m) m = +d.w; }
      return m;
    }
    function totalWh() { return dailyWh() * S.days * S.reserve; }
    function needAh() { return S.volt > 0 ? totalWh() / S.volt : 0; }
    function dod() { return TECH[S.tech].dod; }
    function recGrossAh() { return needAh() / dod(); }
    function grossAh() { return (S.battAh !== null && S.battAh > 0) ? S.battAh : recGrossAh(); }
    function usableWh() { return grossAh() * S.volt * dod(); }
    function battKg() { return grossAh() / 100 * TECH[S.tech].kg * (S.volt / 12); }

    function recWp() { return S.sun > 0 ? dailyWh() / S.sun * S.reserve : 0; }
    function wp() { return (S.solarWp !== null && S.solarWp > 0) ? S.solarWp : recWp(); }
    function ctrlA() { return S.volt > 0 ? wp() / S.volt : 0; }
    function ctrlSize() { return up(CTRL_SIZES, ctrlA() * 1.1); }
    function stringV() { return S.voc * S.series * 1.2; }
    function stringA() { return S.isc * S.parallel * 1.25; }

    function invW() { return acSimW() * 1.3; }
    function invSize() { return up(INV_SIZES, invW()); }
    /* DC-Strom, den der Wechselrichter bei Dauerlast aus der Batterie zieht.
       Der Wirkungsgrad gehoert hier zwingend hinein – sonst wird der
       Batteriekreis systematisch zu klein abgesichert. */
    function invDcA() { return (acSimW() > 0 && S.volt > 0) ? invSize() / (INV_ETA * S.volt) : 0; }

    function boostA() { return S.alt > 0 ? down(BOOST_SIZES, S.alt / 3) : 0; }
    function boostWhPerH() { return boostA() * S.volt * BOOST_ETA; }
    function driveWhPerH() { return boostWhPerH() + (S.altCharger ? ALT_CHARGER_W * 0.9 : 0); }

    /* Groesster Stromkreis auf der 12/24-V-Seite */
    function autoLoadA() {
      if (S.volt <= 0) return 0;
      if (acSimW() > 0) return invDcA();
      var mx = 0;
      for (var i = 0; i < S.devices.length; i++) { var d = S.devices[i]; if (d.on && (+d.w || 0) > mx) mx = +d.w; }
      return Math.max(20, mx / S.volt);
    }
    function loadA() { return (S.cabI !== null && S.cabI > 0) ? S.cabI : autoLoadA(); }

    /* Sicherung: naechste Normgroesse ueber dem Betriebsstrom, mit etwas
       Luft fuer Anlaufstroeme und Toleranzen. */
    function fuseA() { return up(FUSE_SIZES, loadA() * 1.15); }
    /* Querschnitt nach zulaessigem Spannungsabfall */
    function qByDrop() {
      var du = S.volt * S.cabU / 100;
      if (du <= 0) return Q_SIZES[0];
      return up(Q_SIZES, 2 * S.cabL * loadA() / (56 * du));
    }
    /* Querschnitt nach Strombelastbarkeit. Bezugsgroesse ist der
       Sicherungsnennstrom, nicht der Betriebsstrom: die Sicherung muss
       das Kabel schuetzen, sonst loest sie im Fehlerfall spaeter aus,
       als das Kabel es aushaelt. */
    function qByAmp() {
      var need = fuseA();
      for (var i = 0; i < Q_SIZES.length; i++) { if (Q_AMP[Q_SIZES[i]] >= need) return Q_SIZES[i]; }
      return Q_SIZES[Q_SIZES.length - 1];
    }
    function qPick() { return Math.max(qByDrop(), qByAmp()); }
    function cabDriver() { return qByAmp() > qByDrop() ? "Strombelastbarkeit" : "Spannungsabfall"; }
    function cabDropV() { var Q = qPick(); return Q > 0 ? 2 * S.cabL * loadA() / (56 * Q) : 0; }

    /* ============ Wochensimulation ============ */
    var BAD_ORDER = [4, 5, 3, 6, 2, 7, 1], DRIVE_ORDER = [1, 4, 6, 2, 5, 7, 3];
    function week() {
      var cap = usableWh(), soc = cap, out = [], shortfall = 0, firstEmpty = null, low = cap;
      var badSet = {}, drvSet = {};
      for (var i = 0; i < S.bad; i++) badSet[BAD_ORDER[i]] = 1;
      for (var j = 0; j < S.drive; j++) drvSet[DRIVE_ORDER[j]] = 1;
      var use = dailyWh();
      for (var d = 1; d <= 7; d++) {
        var sol = wp() * S.sun * S.pr * (badSet[d] ? 0.25 : 1);
        var drv = drvSet[d] ? driveWhPerH() * S.driveH : 0;
        var land = (S.land && d === 7);
        var inp = sol + drv;
        soc = soc + inp - use;
        if (soc < 0) { shortfall += -soc; if (firstEmpty === null) firstEmpty = d; soc = 0; }
        if (soc > cap) soc = cap;
        /* Landstrom fuellt am Ende des Tages auf voll auf – der Verbrauch
           des Tages ist vorher regulaer abgezogen worden. */
        if (land) soc = cap;
        if (soc < low) low = soc;
        out.push({ d: d, soc: soc, inp: inp, sol: sol, drv: drv, bad: !!badSet[d], drive: !!drvSet[d], land: land });
      }
      return { days: out, cap: cap, shortfall: shortfall, firstEmpty: firstEmpty, low: low, pct: cap > 0 ? low / cap * 100 : 0 };
    }

    /* Wochensaldo ohne Kapazitaetsgrenze: was ueber sieben Tage
       hereinkommt, gegen das, was herausgeht.

       Das ist eine ANDERE Frage als "traegt die Batterie die Woche".
       Ein sehr grosser Speicher traegt jede einzelne Woche, auch bei
       negativem Saldo — er startet ja voll. Nachhaltig ist das Setup
       trotzdem nicht: in der zweiten Woche steht man schlechter da.
       Genau hier ist mehr Speicher nicht der Hebel. */
    function weekBalanceWh() {
      var use = dailyWh(), inTotal = 0;
      var badSet = {}, drvSet = {};
      for (var i = 0; i < S.bad; i++) badSet[BAD_ORDER[i]] = 1;
      for (var j = 0; j < S.drive; j++) drvSet[DRIVE_ORDER[j]] = 1;
      for (var d = 1; d <= 7; d++) {
        inTotal += wp() * S.sun * S.pr * (badSet[d] ? 0.25 : 1);
        if (drvSet[d]) inTotal += driveWhPerH() * S.driveH;
      }
      return inTotal - use * 7;
    }
    /* Mit Landstrom am Wochenende ist die Bilanz per Definition gedeckt. */
    function isSustainable() { return S.land || weekBalanceWh() >= 0; }

    /* Kleinste Bruttokapazitaet, die die sieben Tage traegt.
       Obergrenze: ein Speicher mit sieben Tagesverbraeuchen kommt
       immer durch, selbst ganz ohne Ertrag — damit ist die Suche
       garantiert loesbar. Sie ist ausserdem monoton (eine groessere
       Batterie kann nie frueher leer sein), deshalb binaer. */
    function minViableAh() {
      if (dailyWh() <= 0) return 0;
      var keep = S.battAh, step = 10;
      var perAh = S.volt * dod();
      if (perAh <= 0) return null;
      var hi = Math.max(1, Math.ceil(dailyWh() * 7 * 1.02 / perAh / step));
      S.battAh = hi * step;
      if (week().firstEmpty !== null) { S.battAh = keep; return null; }
      var lo = 1;
      while (lo < hi) {
        var mid = Math.floor((lo + hi) / 2);
        S.battAh = mid * step;
        if (week().firstEmpty === null) hi = mid; else lo = mid + 1;
      }
      S.battAh = keep;
      return hi * step;
    }

    /* ============ Schritte ============ */

    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
    function round2(v) { return Math.round(v * 100) / 100; }
    function num(v, fb) { var n = parseFloat(String(v).replace(",", ".")); return isFinite(n) ? n : fb; }
    function plural(n, one, many) { return n === 1 ? one : many; }

    /* Laufzeiten unter einer Stunde in Minuten: "9 Min." versteht
       jeder, "0,15 h" kaum jemand. */
    function fmtH(v) {
      if (v <= 0) return "0 Std.";
      if (v < 1) return Math.round(v * 60) + " Min.";
      return nf(v, v % 1 ? 1 : 0) + " Std.";
    }
    /* Raster fuer die Laufzeit-Knoepfe: kleine Schritte bei kurzen
       Laufzeiten, groessere bei langen. */
    var H_LADDER = [0, 5 / 60, 10 / 60, 0.25, 0.5, 0.75, 1, 1.5, 2, 2.5, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 18, 20, 24];
    function hNext(v, dir) {
      var i;
      if (dir > 0) {
        for (i = 0; i < H_LADDER.length; i++) { if (H_LADDER[i] > v + 1e-6) return H_LADDER[i]; }
        return 24;
      }
      for (i = H_LADDER.length - 1; i >= 0; i--) { if (H_LADDER[i] < v - 1e-6) return H_LADDER[i]; }
      return 0;
    }

    /* ---------- Plus-Minus-Regler ----------
       Grosse Knoepfe statt eines Zahlenfelds: kein Tippen, keine
       Tastatur auf dem Telefon, kein Komma-oder-Punkt-Problem. */
    function makeStepper(host, o) {
      host.innerHTML = "";
      host.setAttribute("role", "group");
      host.setAttribute("aria-label", o.label);
      var minus = el("button", "ag-sb");
      minus.type = "button";
      minus.innerHTML = '<span aria-hidden="true">−</span>';
      minus.setAttribute("aria-label", o.label + ": weniger");
      var val = el("span", "ag-sval");
      val.setAttribute("aria-live", "polite");
      var plus = el("button", "ag-sb");
      plus.type = "button";
      plus.innerHTML = '<span aria-hidden="true">+</span>';
      plus.setAttribute("aria-label", o.label + ": mehr");
      function sync() {
        var v = o.get();
        val.textContent = o.fmt(v);
        minus.disabled = v <= o.min + 1e-6;
        plus.disabled = v >= o.max - 1e-6;
      }
      function change(dir) {
        o.set(round2(clamp(o.next(o.get(), dir), o.min, o.max)));
        sync();
      }
      minus.addEventListener("click", function () { change(-1); });
      plus.addEventListener("click", function () { change(1); });
      host.appendChild(minus);
      host.appendChild(val);
      host.appendChild(plus);
      sync();
      return sync;
    }

    var stepperSyncs = [];
    function initSteppers() {
      var hosts = root.querySelectorAll(".ag-stepper[data-key]");
      for (var i = 0; i < hosts.length; i++) {
        (function (h) {
          var key = h.getAttribute("data-key");
          var step = num(h.getAttribute("data-step"), 1);
          var one = h.getAttribute("data-unit1") || h.getAttribute("data-unit");
          var many = h.getAttribute("data-unit");
          stepperSyncs.push(makeStepper(h, {
            label: h.getAttribute("data-label") || key,
            min: num(h.getAttribute("data-min"), 0),
            max: num(h.getAttribute("data-max"), 99),
            get: function () { return +S[key] || 0; },
            set: function (v) { S[key] = v; render(); save(); },
            next: function (v, dir) { return v + dir * step; },
            fmt: function (v) { return nf(v, v % 1 ? 1 : 0) + " " + (v === 1 ? one : many); }
          }));
        })(hosts[i]);
      }
    }

    /* ---------- Fortschritt und Navigation ---------- */
    function buildProgress() {
      var bar = q("#ag-progbar");
      bar.innerHTML = "";
      for (var i = 0; i < STEPS.length; i++) bar.appendChild(el("li"));
    }
    function syncProgress() {
      var lis = q("#ag-progbar").children;
      for (var i = 0; i < lis.length; i++) lis[i].className = i <= S.step ? "ag-done" : "";
      q("#ag-progtext").textContent = "Schritt " + (S.step + 1) + " von " + STEPS.length;
      q("#ag-progname").textContent = STEPS[S.step].t;
    }

    function stickyOffset() {
      var v = parseFloat(getComputedStyle(root).getPropertyValue("--ag-sticky-top"));
      return isFinite(v) ? v : 0;
    }

    function go(i, noScroll) {
      S.step = clamp(i, 0, STEPS.length - 1);
      var secs = root.querySelectorAll(".ag-sec");
      for (var k = 0; k < secs.length; k++) secs[k].classList.toggle("ag-on", secs[k].id === "ag-" + STEPS[S.step].id);
      syncProgress();
      var last = S.step === STEPS.length - 1;
      q("#ag-prev").hidden = S.step === 0;
      q("#ag-next").hidden = last;
      if (!last) q("#ag-nextlbl").textContent = "Weiter: " + STEPS[S.step + 1].t;
      q("#ag-live").textContent = "Schritt " + (S.step + 1) + " von " + STEPS.length + ": " + STEPS[S.step].t;
      renderAcList();
      render();
      if (!noScroll) {
        /* Nicht window.scrollTo(0) – in einer Shop-Seite wuerde das an
           den Seitenanfang ueber dem Theme-Header springen. */
        var y = root.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - stickyOffset() - 8;
        window.scrollTo(0, Math.max(0, y));
        /* Fokus auf die neue Ueberschrift, damit Tastatur- und
           Vorlesenutzer nicht am Seitenende haengen bleiben. */
        var h = q("#ag-" + STEPS[S.step].id + " .ag-h1");
        if (h) { try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
      }
      save();
    }

    /* ---------- Auswahlkarten ---------- */
    function buildOpts(host, map, onPick) {
      host.innerHTML = "";
      Object.keys(map).forEach(function (k) {
        var b = el("button", "ag-opt");
        b.type = "button";
        b.setAttribute("data-k", k);
        var chk = el("span", "ag-opt-check");
        chk.setAttribute("aria-hidden", "true");
        b.appendChild(chk);
        b.appendChild(el("strong", null, map[k].label));
        b.appendChild(el("span", "ag-opt-sub", map[k].sub || ""));
        b.appendChild(el("span", "ag-opt-meta"));
        b.addEventListener("click", function () { onPick(k); });
        host.appendChild(b);
      });
    }
    function syncOpts(host, current, meta) {
      var bs = host.querySelectorAll(".ag-opt");
      for (var i = 0; i < bs.length; i++) {
        var k = bs[i].getAttribute("data-k");
        bs[i].setAttribute("aria-pressed", k === current ? "true" : "false");
        var m = meta ? meta(k) : "";
        var mm = bs[i].querySelector(".ag-opt-meta");
        mm.textContent = m;
        mm.hidden = !m;
      }
    }

    /* ---------- Geraete ---------- */
    function hasDevice(n) {
      for (var i = 0; i < S.devices.length; i++) { if (S.devices[i].n === n) return true; }
      return false;
    }
    function buildCatalog() {
      var host = q("#ag-catalog");
      host.innerHTML = "";
      CATALOG.forEach(function (grp) {
        host.appendChild(el("h4", "ag-catname", grp.g));
        var wrap = el("div", "ag-tiles");
        grp.items.forEach(function (it) {
          var b = el("button", "ag-tile");
          b.type = "button";
          b.setAttribute("data-n", it.n);
          var chk = el("span", "ag-tile-check");
          chk.setAttribute("aria-hidden", "true");
          b.appendChild(chk);
          var tx = el("span", "ag-tile-txt");
          tx.appendChild(el("b", null, it.n));
          tx.appendChild(el("small", null, "ca. " + nf(it.w) + " W" + (it.ac ? " · 230 V" : "")));
          b.appendChild(tx);
          b.addEventListener("click", function () { toggleDevice(it); });
          wrap.appendChild(b);
        });
        host.appendChild(wrap);
      });
    }
    function syncCatalog() {
      var ts = root.querySelectorAll(".ag-tile");
      for (var i = 0; i < ts.length; i++) ts[i].setAttribute("aria-pressed", hasDevice(ts[i].getAttribute("data-n")) ? "true" : "false");
    }
    function toggleDevice(it) {
      if (hasDevice(it.n)) S.devices = S.devices.filter(function (d) { return d.n !== it.n; });
      else S.devices.push(D(it.n, it.w, it.h, it.ac, it.ac));
      devicesChanged();
    }
    function devicesChanged() {
      renderDevices();
      syncCatalog();
      renderAcList();
      render();
      save();
    }

    function renderDevices() {
      var list = q("#ag-devlist");
      list.innerHTML = "";
      var empty = S.devices.length === 0;
      q("#ag-devempty").hidden = !empty;
      list.hidden = empty;
      q("#ag-totalbox").hidden = empty;

      S.devices.forEach(function (d) {
        var li = el("li", "ag-dev");

        var head = el("div", "ag-dev-head");
        head.appendChild(el("b", "ag-dev-name", d.n));
        if (d.ac) head.appendChild(el("span", "ag-tag", "230 V"));
        var rm = el("button", "ag-linkbtn", "Entfernen");
        rm.type = "button";
        rm.setAttribute("aria-label", d.n + " entfernen");
        rm.addEventListener("click", function () {
          S.devices = S.devices.filter(function (o) { return o !== d; });
          devicesChanged();
        });
        head.appendChild(rm);
        li.appendChild(head);

        var body = el("div", "ag-dev-body");

        var fw = el("label", "ag-dev-field");
        fw.appendChild(el("span", "ag-dev-lbl", "Leistung"));
        var wrapIn = el("span", "ag-unitin");
        var wi = document.createElement("input");
        wi.type = "number"; wi.min = "0"; wi.step = "1"; wi.value = d.w;
        wi.setAttribute("inputmode", "numeric");
        wrapIn.appendChild(wi);
        wrapIn.appendChild(el("span", null, "Watt"));
        fw.appendChild(wrapIn);
        body.appendChild(fw);

        var fh = el("div", "ag-dev-field");
        fh.appendChild(el("span", "ag-dev-lbl", "Laufzeit pro Tag"));
        var sh = el("div", "ag-stepper ag-stepper-s");
        fh.appendChild(sh);
        body.appendChild(fh);

        var whBox = el("div", "ag-dev-wh");
        whBox.appendChild(el("span", "ag-dev-lbl", "Verbrauch"));
        var whb = el("b");
        whBox.appendChild(whb);
        body.appendChild(whBox);

        li.appendChild(body);
        list.appendChild(li);

        /* Nur die eigene Zeile und die Summe neu schreiben – die Liste
           neu aufzubauen, wuerde dem Feld beim Tippen den Fokus nehmen. */
        function upd() {
          whb.textContent = nf(deviceWh(d)) + " Wh";
          q("#ag-devtotal").textContent = nf(dailyWh()) + " Wh";
        }
        wi.addEventListener("input", function () {
          d.w = wi.value === "" ? 0 : Math.max(0, num(wi.value, 0));
          upd(); render(); save();
        });
        makeStepper(sh, {
          label: "Laufzeit " + d.n, min: 0, max: 24,
          get: function () { return +d.h || 0; },
          set: function (v) { d.h = v; upd(); render(); save(); },
          next: hNext, fmt: fmtH
        });
        upd();
      });
      q("#ag-devtotal").textContent = nf(dailyWh()) + " Wh";
    }

    function renderAcList() {
      var host = q("#ag-aclist");
      host.innerHTML = "";
      var any = false;
      S.devices.forEach(function (d) {
        if (!d.ac || !d.on) return;
        any = true;
        var l = el("label", "ag-check ag-check-row");
        var cb = document.createElement("input");
        cb.type = "checkbox";
        cb.checked = d.sim;
        cb.addEventListener("change", function () { d.sim = cb.checked; render(); save(); });
        l.appendChild(cb);
        var t = el("span", "ag-check-txt");
        t.appendChild(el("span", null, d.n));
        t.appendChild(el("b", null, nf(d.w) + " W"));
        l.appendChild(t);
        host.appendChild(l);
      });
      q("#ag-acnone").hidden = any;
      q("#ag-acyes").hidden = !any;
    }

    /* ---------- Antwortbloecke ----------
       Jede Antwort hat dieselbe Form: eine grosse Zahl mit kurzer
       Erklaerung, darunter die Zwischenwerte als ruhige Liste. */
    function answers(host, items, facts) {
      var h = '<div class="ag-answers">';
      items.forEach(function (it) {
        h += '<div class="ag-answer"><p class="ag-a-label">' + esc(it.label) + '</p>' +
          '<p class="ag-a-value">' + esc(it.value) + (it.unit ? ' <span>' + esc(it.unit) + '</span>' : '') + '</p>' +
          (it.note ? '<p class="ag-a-note">' + esc(it.note) + '</p>' : '') + '</div>';
      });
      h += '</div>';
      if (facts && facts.length) {
        h += '<dl class="ag-facts">';
        facts.forEach(function (f) { h += '<div><dt>' + esc(f[0]) + '</dt><dd>' + esc(f[1]) + '</dd></div>'; });
        h += '</dl>';
      }
      host.innerHTML = h;
    }
    function qFmt(v) { return nf(v, v % 1 ? 1 : 0); }

    /* ---------- Wochendiagramm ---------- */
    function renderChart() {
      var w = week(), W = 320, H = 156, pad = { l: 30, r: 10, t: 10, b: 32 };
      var iw = W - pad.l - pad.r, ih = H - pad.t - pad.b;
      var cap = w.cap || 1;
      function X(i) { return pad.l + iw * (i / 6); }
      function Y(v) { return pad.t + ih * (1 - Math.max(0, Math.min(1, v / cap))); }

      var pts = w.days.map(function (d, i) { return X(i) + "," + Y(d.soc); }).join(" ");
      var area = "M" + pad.l + "," + (pad.t + ih) + " L" +
        w.days.map(function (d, i) { return X(i) + "," + Y(d.soc); }).join(" L") +
        " L" + (pad.l + iw) + "," + (pad.t + ih) + " Z";

      var s = '<svg class="ag-chart" viewBox="0 0 ' + W + " " + H + '" role="img" aria-labelledby="ag-charttitle">';
      s += '<title id="ag-charttitle">Ladezustand der Batterie über sieben Tage</title>';
      [0, 0.5, 1].forEach(function (f) {
        var y = pad.t + ih * (1 - f);
        s += '<line class="ag-c-grid" x1="' + pad.l + '" y1="' + y + '" x2="' + (pad.l + iw) + '" y2="' + y + '"/>';
        s += '<text class="ag-c-axis" x="' + (pad.l - 6) + '" y="' + (y + 2.5) + '" text-anchor="end">' + Math.round(f * 100) + " %</text>";
      });
      var maxIn = 1;
      w.days.forEach(function (d) { if (d.inp > maxIn) maxIn = d.inp; });
      w.days.forEach(function (d, i) {
        var bh = Math.max(0, ih * 0.32 * (d.inp / maxIn));
        var cls = "ag-c-bar" + (d.land ? " ag-c-land" : (d.bad ? " ag-c-bad" : ""));
        s += '<rect class="' + cls + '" x="' + (X(i) - 6) + '" y="' + (pad.t + ih - bh) + '" width="12" height="' + bh + '" rx="2"/>';
      });
      s += '<path class="ag-c-area" d="' + area + '"/>';
      s += '<polyline class="ag-c-line" points="' + pts + '"/>';
      w.days.forEach(function (d, i) {
        var emptyDay = d.soc <= 0.001;
        s += '<circle class="ag-c-dot' + (emptyDay ? " ag-c-empty" : "") + '" cx="' + X(i) + '" cy="' + Y(d.soc) + '" r="' + (emptyDay ? 3.6 : 2.8) + '"/>';
        s += '<text class="ag-c-axis" x="' + X(i) + '" y="' + (pad.t + ih + 12) + '" text-anchor="middle">Tag ' + d.d + "</text>";
        if (d.drive) s += '<text class="ag-c-mark" x="' + X(i) + '" y="' + (pad.t + ih + 22) + '" text-anchor="middle">Fahrt</text>';
      });
      s += "</svg>";
      q("#ag-chart").innerHTML = s;

      var v = q("#ag-verdict");
      if (w.cap <= 0 || dailyWh() <= 0) {
        v.className = "ag-verdict";
        v.innerHTML = "<b>Noch keine Geräte ausgewählt.</b> Sobald Du in Schritt 2 Geräte auswählst, rechnet der Wochencheck mit.";
        return;
      }
      if (w.firstEmpty === null && isSustainable()) {
        var lowest = w.days.reduce(function (a, b) { return b.soc < a.soc ? b : a; });
        v.className = "ag-verdict";
        v.innerHTML = "<b>Ja, das reicht.</b> Die Batterie kommt gut durch die Woche. Am knappsten wird es an Tag " +
          lowest.d + " mit noch " + nf(w.pct) + " % Ladung.";
      } else if (w.firstEmpty === null) {
        v.className = "ag-verdict ag-bad";
        v.innerHTML = "<b>Diese Woche reicht es gerade noch.</b> Aber nur, weil die Batterie voll startet. Über die Woche fehlen rund " +
          nf(-weekBalanceWh()) + " Wh — in der zweiten Woche wäre sie leer. Mehr Fahrtage oder mehr Solarleistung helfen.";
      } else {
        var extraWp = Math.ceil((w.shortfall / (7 * S.sun * S.pr)) / 10) * 10;
        v.className = "ag-verdict ag-bad";
        v.innerHTML = "<b>Nein, an Tag " + w.firstEmpty + " ist die Batterie leer.</b> Es fehlen rund " +
          nf(w.shortfall) + " Wh. Abhilfe: etwa " + nf(extraWp) + " Wp mehr Solarleistung, ein zusätzlicher Fahrtag oder Landstrom am Wochenende.";
      }
    }

    /* ---------- Ergebnis ---------- */
    function shopList() {
      var host = q("#ag-shoplist");
      host.innerHTML = "";
      var rows = [
        { k: "Batterie", v: nf(grossAh()) + " Ah", n: TECH[S.tech].label + " mit " + S.volt + " V", s: 2 },
        { k: "Solarmodule", v: nf(wp()) + " Wp", n: "gern aus mehreren Modulen zusammengesetzt", s: 3 },
        { k: "Solar-Laderegler", v: "MPPT " + nf(ctrlSize()) + " A", n: "passend zu Batteriespannung und Batterieart", s: 3 }
      ];
      if (acSimW() > 0) rows.push({ k: "Wechselrichter", v: nf(invSize()) + " W", n: "reiner Sinus", s: 4 });
      if (S.alt > 0 && S.drive > 0) rows.push({ k: "Ladebooster", v: nf(boostA()) + " A", n: "lädt die Batterie während der Fahrt", s: 5 });
      rows.push({ k: "Hauptkabel", v: qFmt(qPick()) + " mm²", n: "für " + nf(S.cabL, S.cabL % 1 ? 1 : 0) + " m zwischen Batterie und " + (acSimW() > 0 ? "Wechselrichter" : "Verteiler"), s: 6 });
      rows.push({ k: "Hauptsicherung", v: nf(fuseA()) + " A", n: "direkt am Pluspol der Batterie", s: 6 });

      rows.forEach(function (r) {
        var li = el("li", "ag-shoprow");
        var t = el("div", "ag-shop-txt");
        t.appendChild(el("b", null, r.k));
        t.appendChild(el("span", null, r.n));
        li.appendChild(t);
        li.appendChild(el("span", "ag-shop-val", r.v));
        var b = el("button", "ag-linkbtn ag-noprint", "Ändern");
        b.type = "button";
        b.setAttribute("aria-label", r.k + " ändern");
        b.addEventListener("click", function () { go(r.s); });
        li.appendChild(b);
        host.appendChild(li);
      });
    }

    function finalVerdict() {
      var box = q("#ag-finalverdict"), w = week();
      if (dailyWh() <= 0) {
        box.className = "ag-verdictbox ag-bad";
        box.innerHTML = "<b>Es fehlen noch Deine Geräte.</b> Gehe zurück zu Schritt 2 und wähle aus, was bei Dir mitfährt — ohne das kann nichts berechnet werden.";
        return;
      }
      if (w.firstEmpty !== null) {
        box.className = "ag-verdictbox ag-bad";
        box.innerHTML = "<b>So reicht der Strom noch nicht.</b> In der Beispielwoche ist die Batterie an Tag " + w.firstEmpty +
          " leer. Im Wochencheck (Schritt 6) siehst Du, was hilft: mehr Fahrtage, mehr Solarleistung oder Landstrom.";
        return;
      }
      if (!isSustainable()) {
        box.className = "ag-verdictbox ag-bad";
        box.innerHTML = "<b>Eine Woche geht, auf Dauer nicht.</b> Es wird mehr Strom verbraucht als nachgeladen. Eine größere Batterie hilft hier nicht — mehr Solarleistung oder mehr Fahrtage schon.";
        return;
      }
      box.className = "ag-verdictbox";
      box.innerHTML = "<b>Deine Anlage passt zu Deinem Reisen.</b> Auch an der knappsten Stelle der Woche bleiben noch " +
        nf(w.pct) + " % Ladung übrig.";
    }

    function planSheet() {
      var w = week(), h = "";
      function dl(rows) {
        var out = "<dl>";
        rows.forEach(function (r) { out += "<dt>" + r[0] + "</dt><dd>" + r[1] + "</dd>"; });
        return out + "</dl>";
      }
      var bal = weekBalanceWh();
      h += "<h4>Verbrauch</h4>" + dl([
        ["Reisestil", esc(PROFILES[S.profile].label)],
        ["Täglicher Verbrauch", nf(dailyWh()) + " Wh"],
        ["Tage ohne Strom von außen", S.days],
        ["Sicherheitsreserve", nf((S.reserve - 1) * 100) + " %"],
        ["Gesamter Energiebedarf", nf(totalWh()) + " Wh"],
        ["Bordspannung", S.volt + " V"]
      ]);
      h += "<h4>Batterie</h4>" + dl([
        ["Bauart", TECH[S.tech].label],
        ["Bruttokapazität", nf(grossAh()) + " Ah (" + nf(grossAh() * S.volt) + " Wh)"],
        ["Nutzbare Kapazität nötig", nf(needAh()) + " Ah"],
        ["Tatsächlich nutzbar", nf(usableWh()) + " Wh"],
        ["Gewicht (geschätzt)", nf(battKg()) + " kg"],
        ["Ladezyklen", TECH[S.tech].cyc]
      ]);
      h += "<h4>Solar</h4>" + dl([
        ["Region und Jahreszeit", SUN[S.region].label + ", " + SEASON[S.season]],
        ["Sonnenstunden pro Tag", nf(S.sun, 1) + " h"],
        ["Solarleistung", nf(wp()) + " Wp"],
        ["Laderegler", "MPPT " + nf(ctrlSize()) + " A"]
      ]);
      h += "<h4>Wechselrichter</h4>" + dl([
        ["Gleichzeitige 230-V-Last", nf(acSimW()) + " W"],
        ["Empfohlene Dauerleistung", acSimW() > 0 ? nf(invSize()) + " W, reiner Sinus" : "nicht nötig"],
        ["Größte einzelne 230-V-Last", nf(acMaxW()) + " W"],
        ["Strom aus der Batterie", acSimW() > 0 ? nf(invDcA()) + " A" : "–"]
      ]);
      h += "<h4>Laden unterwegs</h4>" + dl([
        ["Fahrtage pro Woche", S.drive + " × " + nf(S.driveH, S.driveH % 1 ? 1 : 0) + " Std."],
        ["Lichtmaschine", nf(S.alt) + " A"],
        ["Ladebooster", nf(boostA()) + " A"],
        ["Landstrom am Wochenende", S.land ? "ja" : "nein"]
      ]);
      h += "<h4>Kabel und Sicherung</h4>" + dl([
        ["Strom im Hauptkreis", nf(loadA()) + " A"],
        ["Kabellänge (einfach)", nf(S.cabL, 1) + " m"],
        ["Kabelquerschnitt", qFmt(qPick()) + " mm²"],
        ["Hauptsicherung", nf(fuseA()) + " A"],
        ["Spannungsverlust", nf(cabDropV(), 2) + " V (" + nf(cabDropV() / S.volt * 100, 1) + " %)"]
      ]);
      h += "<h4>Wochencheck</h4>" + dl([
        ["Niedrigster Ladestand", nf(w.pct) + " %"],
        ["Fehlende Energie", w.shortfall > 0 ? nf(w.shortfall) + " Wh" : "keine"],
        ["Energiesaldo der Woche", (bal >= 0 ? "+" : "−") + nf(Math.abs(bal)) + " Wh"],
        ["Tage mit schlechtem Wetter", S.bad]
      ]);

      var ref = PROFILES[S.profile].ref;
      if (ref) {
        h += "<h4>Vergleich mit dem Ratgeber (" + esc(PROFILES[S.profile].label) + ")</h4>" + dl([
          ["Verbrauch", nf(dailyWh()) + " Wh · Ratgeber: " + ref.wh],
          ["Batterie", nf(grossAh()) + " Ah · Ratgeber: " + ref.batt],
          ["Solar", nf(wp()) + " Wp · Ratgeber: " + ref.solar],
          ["Wechselrichter", (acSimW() > 0 ? nf(invSize()) + " W" : "–") + " · Ratgeber: " + ref.inv]
        ]);
      }

      h += "<h4>Vor dem Einbau abhaken</h4><ul class=\"ag-checklist\">";
      ["Kabelquerschnitte für alle Stromkreise berechnet", "Sicherung dicht an jedem Pluspol",
        "Jede Batterie einzeln abgesichert", "Hauptschalter zum Trennen eingeplant",
        "FI-Schutzschalter für den 230-V-Kreis", "Ladegerät und Ladebooster passen zur Batterieart",
        "Laderegler mit ausreichend Lüftung eingebaut", "Laden bei Frost bedacht",
        "Rauchmelder im Wohnraum", "Feuerlöscher griffbereit",
        "Batterien gegen Verrutschen gesichert", "Zuladung und Achslast geprüft"].forEach(function (t) {
          h += '<li><label class="ag-check"><input type="checkbox"> <span>' + t + "</span></label></li>";
        });
      h += "</ul>";
      q("#ag-plansheet").innerHTML = h;
    }

    /* ============ Render ============ */
    function render() {
      syncOpts(q("#ag-profilecards"), S.profile, function (k) {
        var sum = 0;
        PROFILES[k].dev().forEach(function (d) { if (d.on) sum += d.w * d.h; });
        return sum > 0 ? "rund " + nf(sum) + " Wh am Tag" : "";
      });
      syncOpts(q("#ag-techcards"), S.tech, function (k) {
        var o = TECH[k];
        if (dailyWh() <= 0) return "";
        return "Für Dich nötig: rund " + nf(needAh() / o.dod) + " Ah, " + nf(needAh() / o.dod / 100 * o.kg * (S.volt / 12)) + " kg";
      });
      var pr = PROFILES[S.profile];
      q("#ag-battrec").textContent = pr.batt
        ? "Für „" + pr.label + "“ empfiehlt der Ratgeber: " + pr.batt + "."
        : "Welche Bauart passt, hängt vor allem davon ab, wie oft und wie lange Du frei stehst.";

      /* --- Batterie --- */
      var mv = minViableAh();
      var own = S.battAh !== null && S.battAh > 0;
      answers(q("#ag-battans"), [{
        label: own ? "Deine Batterie" : "Empfohlene Batterie",
        value: nf(grossAh()), unit: "Ah",
        note: TECH[S.tech].label + " · " + S.volt + " V · rund " + nf(battKg()) + " kg"
      }], [
        ["Energiebedarf für " + S.days + " " + plural(S.days, "Tag", "Tage") + " mit Reserve", nf(totalWh()) + " Wh"],
        ["Davon wirklich entnehmbar nötig", nf(needAh()) + " Ah"],
        ["Mit Deinen Ladequellen würden reichen", mv ? nf(mv) + " Ah" : "–"]
      ]);
      var bh = q("#ag-battadvice");
      if (dailyWh() <= 0) {
        bh.className = "ag-note";
        bh.textContent = "Sobald Du in Schritt 2 Geräte auswählst, wird hier gerechnet.";
      } else if (!isSustainable()) {
        bh.className = "ag-note ag-warn";
        bh.innerHTML = "<b>Mehr Speicher ist hier nicht die Lösung.</b> Über eine Woche wird mehr Strom verbraucht als nachgeladen. Eine größere Batterie verschiebt das Problem nur — mehr Solarleistung oder mehr Fahrtage helfen. Das prüfst Du im Wochencheck.";
      } else if (mv && mv < recGrossAh() * 0.6) {
        bh.className = "ag-note";
        bh.innerHTML = "<b>Die Empfehlung hat viel Puffer.</b> Sie geht davon aus, dass " + S.days + " " + plural(S.days, "Tag", "Tage") +
          " lang gar nichts nachgeladen wird. Mit Sonne und Fahrten kämen schon " + nf(mv) + " Ah durch die Woche. Wie viel Reserve Du möchtest, entscheidest Du.";
      } else {
        bh.className = "ag-note";
        bh.innerHTML = "<b>Diese Größe passt gut zu Deinem Alltag.</b> Auch mit Deinen Ladequellen bräuchtest Du kaum weniger.";
      }

      /* --- Solar --- */
      var ownWp = S.solarWp !== null && S.solarWp > 0;
      answers(q("#ag-solarans"), [
        { label: ownWp ? "Deine Solarleistung" : "Empfohlene Solarleistung", value: nf(wp()), unit: "Wp",
          note: "bei rund " + nf(S.sun, S.sun % 1 ? 1 : 0) + " Sonnenstunden am Tag" },
        { label: "Passender Laderegler", value: "MPPT " + nf(ctrlSize()), unit: "A",
          note: "für " + S.volt + "-V-Batterien" }
      ], [
        ["Ertrag an einem normalen Tag", "rund " + nf(wp() * S.sun * S.pr) + " Wh"],
        ["Dein Verbrauch pro Tag", nf(dailyWh()) + " Wh"]
      ]);
      answers(q("#ag-stringans"), [], [
        ["Spannung bei Kälte (+20 %)", nf(stringV(), 1) + " V"],
        ["Eingangsstrom (+25 %)", nf(stringA(), 1) + " A"],
        ["Der Regler muss mindestens aushalten", nf(Math.ceil(stringV() / 10) * 10) + " V und " + nf(Math.ceil(stringA())) + " A"]
      ]);
      q("#ag-sunsrc").hidden = !!SUN[S.region].src;

      /* --- Wechselrichter --- */
      var hasSim = acSimW() > 0;
      answers(q("#ag-invans"), [{
        label: "Empfohlener Wechselrichter",
        value: hasSim ? nf(invSize()) : "–", unit: hasSim ? "W" : "",
        note: hasSim ? "reiner Sinus, als Dauerleistung" : "Hake oben mindestens ein Gerät an."
      }], hasSim ? [
        ["Gleichzeitige Last", nf(acSimW()) + " W"],
        ["Mit 30 % Reserve", nf(invW()) + " W"],
        ["Strom aus der Batterie", "bis " + nf(invDcA()) + " A"]
      ] : []);

      /* --- Wochencheck --- */
      q("#ag-boostout").textContent = S.alt > 0 ? nf(boostA()) + " A" : "–";
      renderChart();

      /* --- Kabel --- */
      answers(q("#ag-cabans"), [
        { label: "Kabelquerschnitt", value: qFmt(qPick()), unit: "mm²",
          note: "zwischen Batterie und " + (hasSim ? "Wechselrichter" : "Verteiler") },
        { label: "Hauptsicherung", value: nf(fuseA()), unit: "A",
          note: "so nah wie möglich am Pluspol" }
      ], [
        ["Strom in diesem Kreis", nf(loadA()) + " A"],
        ["Ausschlaggebend für den Querschnitt", cabDriver()],
        ["Spannungsverlust auf dem Kabel", nf(cabDropV(), 2) + " V (" + nf(cabDropV() / S.volt * 100, 1) + " %)"]
      ]);

      shopList();
      finalVerdict();
      planSheet();
    }

    /* ============ Eingaben ============ */
    function syncInputs() {
      q("#ag-reserve").value = String(S.reserve);
      q("#ag-volt").value = String(S.volt);
      q("#ag-acloss").checked = S.acLoss;
      q("#ag-region").value = S.region;
      q("#ag-season").value = S.season;
      q("#ag-sun").value = S.sun;
      q("#ag-battah").value = S.battAh === null ? "" : S.battAh;
      q("#ag-solarwp").value = S.solarWp === null ? "" : S.solarWp;
      q("#ag-voc").value = S.voc;
      q("#ag-isc").value = S.isc;
      q("#ag-series").value = S.series;
      q("#ag-parallel").value = S.parallel;
      q("#ag-alt").value = S.alt;
      q("#ag-altcharger").checked = S.altCharger;
      q("#ag-land").checked = S.land;
      q("#ag-pr").value = String(S.pr);
      q("#ag-cabi").value = S.cabI === null ? "" : S.cabI;
      q("#ag-cabu").value = String(S.cabU);
      stepperSyncs.forEach(function (f) { f(); });
    }

    function bind(sel, fn) {
      var e = q(sel);
      if (!e) return;
      function h() { fn(e); render(); save(); }
      e.addEventListener("input", h);
      e.addEventListener("change", h);
    }

    /* ============ Speichern ============ */
    var saveTimer = null;
    function save() {
      if (saveTimer) clearTimeout(saveTimer);
      saveTimer = setTimeout(function () {
        try { window.localStorage.setItem(STORE_KEY, JSON.stringify(S)); } catch (e) { /* Privatmodus o. a. */ }
      }, 400);
    }
    function applyPlan(o) {
      var base = freshState();
      Object.keys(base).forEach(function (key) { if (o[key] !== undefined) S[key] = o[key]; });
      if (!Array.isArray(S.devices)) S.devices = [];
      S.devices = S.devices.filter(function (d) { return d && typeof d === "object"; }).map(function (d) {
        uid += 1;
        return { id: "d" + uid, n: String(d.n === undefined ? "Gerät" : d.n), w: num(d.w, 0), h: num(d.h, 0), ac: !!d.ac, on: d.on !== false, sim: !!d.sim };
      });
      if (!PROFILES[S.profile]) S.profile = "eigen";
      if (!TECH[S.tech]) S.tech = "lifepo4";
      if (!SUN[S.region]) S.region = "mitte";
      if (!SEASON[S.season]) S.season = "sommer";
      S.volt = S.volt === 24 ? 24 : 12;
      S.step = clamp(Math.round(num(S.step, 0)), 0, STEPS.length - 1);
    }
    function loadStored() {
      try {
        var raw = window.localStorage.getItem(STORE_KEY);
        if (!raw) return false;
        var o = JSON.parse(raw);
        if (!o || o.v !== 3) return false;
        applyPlan(o);
        return true;
      } catch (e) { return false; }
    }
    /* Rueckfrage im Guide statt window.confirm(): Browser-Dialoge sind
       in eingebetteten Ansichten (z. B. der Artifact-Vorschau) oft
       gesperrt und liefern dann stillschweigend "Abbrechen" – der Knopf
       taete scheinbar nichts. Ausserdem ist eine Rueckfrage direkt am
       Knopf fuer aeltere Nutzer verstaendlicher als ein grauer Dialog. */
    var resetTrigger = null;
    function askReset(btn) {
      var panel = q("#ag-confirm");
      var anchor = btn.closest(".ag-actions, .ag-restored") || btn;
      anchor.parentNode.insertBefore(panel, anchor.nextSibling);
      resetTrigger = btn;
      panel.hidden = false;
      q("#ag-confirm-yes").focus();
    }
    function closeReset() {
      q("#ag-confirm").hidden = true;
      if (resetTrigger && resetTrigger.offsetParent !== null) resetTrigger.focus();
      resetTrigger = null;
    }
    function resetAll() {
      q("#ag-confirm").hidden = true;
      resetTrigger = null;
      try { window.localStorage.removeItem(STORE_KEY); } catch (e) { /* egal */ }
      S = freshState();
      q("#ag-restored").hidden = true;
      q("#ag-adderr").hidden = true;
      q("#ag-addok").hidden = true;
      syncInputs(); renderDevices(); syncCatalog();
      go(0);
    }

    /* ============ Drucken ============
       .ag-printing auf <html> und .ag-print-keep auf der Vorfahrenkette
       sorgen dafuer, dass aus einer Shop-Seite nur der Plan gedruckt
       wird – ohne Theme-Header und Footer. */
    function markPrintChain(on) {
      var node = root.parentNode;
      while (node && node.nodeType === 1 && node !== document.body) {
        node.classList.toggle("ag-print-keep", on);
        node = node.parentNode;
      }
      document.documentElement.classList.toggle("ag-printing", on);
    }
    function doPrint() {
      go(STEPS.length - 1, true);
      var det = q("#ag-plandet"), wasOpen = det.open;
      det.open = true;
      markPrintChain(true);
      var done = false;
      function after() {
        if (done) return;
        done = true;
        markPrintChain(false);
        det.open = wasOpen;
        window.removeEventListener("afterprint", after);
      }
      window.addEventListener("afterprint", after);
      setTimeout(after, 60000);
      setTimeout(function () { window.print(); }, 80);
    }

    /* ============ Aufbau ============ */
    function initInputs() {
      Object.keys(SUN).forEach(function (kk) {
        var o = document.createElement("option");
        o.value = kk; o.textContent = SUN[kk].label;
        q("#ag-region").appendChild(o);
      });
      Object.keys(SEASON).forEach(function (kk) {
        var o = document.createElement("option");
        o.value = kk; o.textContent = SEASON[kk];
        q("#ag-season").appendChild(o);
      });

      buildOpts(q("#ag-profilecards"), PROFILES, function (kk) {
        S.profile = kk;
        S.days = PROFILES[kk].days;
        S.devices = PROFILES[kk].dev();
        S.battAh = null; S.solarWp = null; S.cabI = null;
        syncInputs(); renderDevices(); syncCatalog(); renderAcList(); render(); save();
      });
      buildOpts(q("#ag-techcards"), TECH, function (kk) { S.tech = kk; render(); save(); });

      bind("#ag-reserve", function (e) { S.reserve = num(e.value, 1.25); });
      bind("#ag-volt", function (e) { S.volt = num(e.value, 12); });
      bind("#ag-acloss", function (e) { S.acLoss = e.checked; renderDevices(); });
      bind("#ag-region", function (e) { S.region = e.value; S.sun = SUN[S.region][S.season]; q("#ag-sun").value = S.sun; });
      bind("#ag-season", function (e) { S.season = e.value; S.sun = SUN[S.region][S.season]; q("#ag-sun").value = S.sun; });
      bind("#ag-sun", function (e) { S.sun = Math.max(0.2, num(e.value, 5)); });
      bind("#ag-battah", function (e) { S.battAh = e.value === "" ? null : Math.max(0, num(e.value, 0)); });
      bind("#ag-solarwp", function (e) { S.solarWp = e.value === "" ? null : Math.max(0, num(e.value, 0)); });
      bind("#ag-voc", function (e) { S.voc = Math.max(0, num(e.value, 0)); });
      bind("#ag-isc", function (e) { S.isc = Math.max(0, num(e.value, 0)); });
      bind("#ag-series", function (e) { S.series = Math.max(1, Math.round(num(e.value, 1))); });
      bind("#ag-parallel", function (e) { S.parallel = Math.max(1, Math.round(num(e.value, 1))); });
      bind("#ag-alt", function (e) { S.alt = Math.max(0, num(e.value, 0)); });
      bind("#ag-altcharger", function (e) { S.altCharger = e.checked; });
      bind("#ag-land", function (e) { S.land = e.checked; });
      bind("#ag-pr", function (e) { S.pr = num(e.value, 0.8); });
      bind("#ag-cabi", function (e) { S.cabI = e.value === "" ? null : Math.max(0, num(e.value, 0)); });
      bind("#ag-cabu", function (e) { S.cabU = num(e.value, 3); });

      q("#ag-add").addEventListener("click", function () {
        var n = q("#ag-addname").value.trim();
        var w = num(q("#ag-addw").value, 0), h = num(q("#ag-addh").value, 0);
        var err = q("#ag-adderr"), ok = q("#ag-addok");
        ok.hidden = true;
        function fail(msg, field) { err.textContent = msg; err.hidden = false; q(field).focus(); }
        if (!n) return fail("Bitte gib dem Gerät einen Namen.", "#ag-addname");
        if (!(w > 0)) return fail("Bitte gib die Leistung in Watt an. Sie steht meist auf dem Typenschild oder dem Netzteil.", "#ag-addw");
        if (!(h > 0)) return fail("Bitte gib an, wie viele Stunden das Gerät am Tag läuft. Eine halbe Stunde ist 0,5.", "#ag-addh");
        err.hidden = true;
        var ac = q("#ag-addac").checked;
        S.devices.push(D(n, w, clamp(h, 0, 24), ac, ac));
        q("#ag-addname").value = ""; q("#ag-addw").value = ""; q("#ag-addh").value = ""; q("#ag-addac").checked = false;
        ok.textContent = "„" + n + "“ steht jetzt in Deiner Liste.";
        ok.hidden = false;
        devicesChanged();
      });

      q("#ag-prev").addEventListener("click", function () { go(S.step - 1); });
      q("#ag-next").addEventListener("click", function () { go(S.step + 1); });
      q("#ag-print").addEventListener("click", doPrint);
      q("#ag-reset").addEventListener("click", function () { askReset(q("#ag-reset")); });
      q("#ag-reset2").addEventListener("click", function () { askReset(q("#ag-reset2")); });
      q("#ag-confirm-yes").addEventListener("click", resetAll);
      q("#ag-confirm-no").addEventListener("click", closeReset);
    }

    /* ============ Start ============ */
    buildProgress();
    buildCatalog();
    initInputs();
    initSteppers();

    var restored = loadStored();
    q("#ag-restored").hidden = !restored;

    syncInputs();
    renderDevices();
    syncCatalog();
    go(S.step, true);

  } /* Ende boot() */

  boot();

  /* Der Shopify-Theme-Editor tauscht beim Aendern einer Einstellung nur
     das Markup der Section aus, ohne die Seite neu zu laden. Ohne diesen
     Haken bliebe der Guide im Editor danach leer. */
  document.addEventListener("shopify:section:load", function () { boot(); });
})();
